import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[dbltap]',
})
export class DoubleTapDirective {
  @Output() public dblClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() public dblTapped: EventEmitter<any> = new EventEmitter<any>();

  private readonly DOUBLETAP_INTERVAL = 300;
  private isDoubleTap = false;

  @HostListener('touchstart', ['$event']) public onDoubleTap(e: any) {
    this.handleDoubleTap(e);
  }

  private handleDoubleTap(e: any): void {
    if (!this.isDoubleTap) {
      this.isDoubleTap = true;

      const timeoutId = setTimeout(() => {
        this.isDoubleTap = false;
        clearTimeout(timeoutId);
      }, this.DOUBLETAP_INTERVAL);
    } else {
      this.dblTapped.emit(e);
    }
  }

  @HostListener('dblclick', ['$event']) public onDoubleClick(e: any) {
    this.dblClicked.emit(e);
  }
}
